module.exports = __webpack_public_path__ + "static/media/Poster of Punjab Industrial Exhibition aka Tollinton Market c. 1893.9d18460d.jpg";